import { useState, useRef, useEffect } from 'react';
import s from './ReviewCard.module.scss';
import StarRating from '../../components/StarRating/StarRating';
const ReviewCard = ({
  title,
  rezdyId,
  tourId,
  stars,
  date,
  userType,
  userName,
  review,
  thumb = null,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [cardHeight, setCardHeight] = useState('auto');
  const textRef = useRef(null);

  const toggleReview = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={s.root}>
      {thumb && (
      <div className={s.thumbnailWrapper}>
        <a href={`/tours/${rezdyId}`}>
          <img src={thumb} alt={`${userName}のレビューサムネイル`} className={s.thumbnail} />
        </a>
      </div>
      )}
      <div className={s.textWrapper}>
        <a className={s.title} href={`/tours/${tourId}`}>
          {title??""}
        </a>
        <div className={s.rating}>
          <StarRating score={stars} />
        </div>
        <p className={`${s.reviewText} ${isExpanded ? s.expanded : ''}`}>
          {review}
          </p>
        {!isExpanded && review?.length > 100 && (
            <span className={s.toggleReviewButton} onClick={toggleReview}>続きを読む</span>
          )}
          {isExpanded && (
            <span className={s.toggleReviewButton} onClick={toggleReview}>閉じる</span>
        )}
        <div className={s.details}>
          <span>Review by {userName}</span>
          <span>{date}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
